module.exports = __webpack_public_path__ + "img/anyBUSD.c328012c.svg";